var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5Arrow = function SvgAv5Arrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-variant": "icon-with-background",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "av5_arrow_svg__icon-background",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z",
    fill: "#8399C6",
    "data-no-stroke": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13 6.5 8.77 11 5.01",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-no-fill": "true",
    className: "av5_arrow_svg__inner-vectors"
  })));
};
export { SvgAv5Arrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLXZhcmlhbnQ9Imljb24td2l0aC1iYWNrZ3JvdW5kIiB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aAogICAgICAgIGNsYXNzPSJpY29uLWJhY2tncm91bmQiCiAgICAgICAgZD0iTTkgMThDMTMuOTcwNiAxOCAxOCAxMy45NzA2IDE4IDlDMTggNC4wMjk0NCAxMy45NzA2IDAgOSAwQzQuMDI5NDQgMCAwIDQuMDI5NDQgMCA5QzAgMTMuOTcwNiA0LjAyOTQ0IDE4IDkgMThaIgogICAgICAgIGZpbGw9IiM4Mzk5QzYiCiAgICAgICAgZGF0YS1uby1zdHJva2U9InRydWUiCiAgICAvPgogICAgPGcgY2xhc3M9ImlubmVyLXZlY3RvcnMiPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgIGQ9Ik0xMSAxM0w2LjUgOC43NzAxMUwxMSA1LjAxMDIyIgogICAgICAgICAgICBzdHJva2U9IndoaXRlIgogICAgICAgICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIgogICAgICAgICAgICBkYXRhLW5vLWZpbGw9InRydWUiCiAgICAgICAgLz4KICAgIDwvZz4KPC9zdmc+Cg==";